import React, { ChangeEvent, Fragment, FunctionComponent, useEffect, useState } from "react";
import { Col, Modal, Button, Row } from 'react-bootstrap';
import Select from 'react-select'
import { customSelectStyles } from "./utils/react-select-styles";

interface Props {
    vehicleEntries: VehicleEntry[];
    vehicleTypes: VehicleType[];
    onSetVehicleEntry: (rego: string, vehicleType: string, index: number) => void;
}

interface VehicleType{
  vehicletypecode: string;
  vehicletypedescription: string;
}

interface VehicleEntry {
    vehicleRego: string;
    vehicleType: string;
}

export const VehicleEntryTypeControls: FunctionComponent<Props> = ({ vehicleEntries, vehicleTypes, onSetVehicleEntry }) => {
    const defaultValue = {vehicletypecode: "", vehicletypedescription: ""};
    return (
        <Fragment>
          {vehicleEntries.map((vehicleEntry, i) => (
            <Fragment key={i}>
              <Row>
                <Col md={4} xl={3} className="form-group form-group-4 vehicle-rego ">
                  <label htmlFor="vehicle-rego">Vehicle Rego</label>
                  <input name={`vehicle-rego ${i}`} value={vehicleEntry.vehicleRego} onChange={(e) => onSetVehicleEntry(e.target.value, vehicleEntry.vehicleType, i) } required={i !== (vehicleEntries.length - 1)} maxLength={20}></input>
                </Col>
                <Col md={4} xl={3} className="form-group form-group-4">
                  <label htmlFor="vehicle-type">Vehicle Type</label>
                  <Select<VehicleType> name={`vehicle-type ${i}`} options={vehicleTypes}
                    getOptionLabel={vt => vt.vehicletypedescription}
                    getOptionValue={vt => vt.vehicletypecode}
                    defaultValue={defaultValue}
                    value={vehicleTypes.find(vt => vt.vehicletypecode === vehicleEntry.vehicleType) || defaultValue}
                    onChange={(e) => onSetVehicleEntry(vehicleEntry.vehicleRego, e?.vehicletypecode || "", i) }
                    menuPortalTarget={document.body}
                    styles={customSelectStyles}
                    />
                </Col>
              </Row>
            </Fragment>
          ))}
        </Fragment>
      );
}
